import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import OpenReplay from '@openreplay/tracker';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpenReplayService {
  openReplay: OpenReplay | null = null;

  init(projectKey: string, ingestPoint: string) {
    this.openReplay = new OpenReplay({
      projectKey,
      ingestPoint: ingestPoint,
      defaultInputMode: 0,
      obscureInputDates: false,
      obscureInputEmails: false,
      obscureInputNumbers: false,
      obscureTextEmails: false,
      obscureTextNumbers: false,
      network: {
        capturePayload: true,
        captureInIframes: true,
        failuresOnly: false,
        sessionTokenHeader: false,
        ignoreHeaders: false
      }
    });
    this.openReplay.start();
  }

  identifyUser(value: string) {
    this.openReplay?.setUserID(value);
  }

  sendMetaData(key: string, value: string) {
    this.openReplay?.setMetadata(key, value);
  }

  sendNetworkEvent(event: string, params: { request: HttpRequest<any>, response: HttpResponse<any> }): void {
    const { request, response } = params

    this.openReplay?.event(event + "[request]", {
      method: request.method,
      url: request.url,
      params: request.params
    });

    this.openReplay?.event(event + "[response]", {
      body: response.body,
      status: response.status,
      headers: response.headers
    });
  }

  sendEvent(name: string, data: any) {
    this.openReplay?.event(name, data);
  }
}
